<template>
    <div class="d-block">
        <div class=" mb-4">
            <div class="bg-grid-color">
                <ValidationObserver ref="form" id="form">
                    <form @submit.prevent="onSubmit">
                       
                        <div class="vx-row">
                            <vs-radio color="success" class="mr-3" v-model="movie.kind" vs-value="1" checked>Movie
                            </vs-radio>
                            <vs-radio color="warning" v-model="movie.kind" vs-value="2">Series</vs-radio>
                        </div>
                        <div class="vx-row mt-5 " v-if="movie.kind == 2">
                            <div class="vx-row m-1" v-if="movie.series">
                                <vs-input-number v-model="movie.season" label="Season:" />
                                <vs-input-number v-model="movie.episode" label="Episode:" />
                            </div>
                            <vSelect style="width:400px" class="mt-1 mx-5" :filterable="false" :multiple="false"
                                v-model="movie.series" @search="search" :loading="series_loading"
                                @option:selected="seriesSelected" :reduce="series => series.id" :options="seriesList"
                                label="en_title" placeholder="Main Series">
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        <!-- <img :src="`${option.poster}`" width="30"/> -->
                                        {{ option.en_title }} - {{ option.year }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center flex">
                                        <img :src="`${option.poster}`" width="50" /> <br>
                                        <span class="m-1">
                                            <h3> {{ option.en_title }}</h3>
                                            <h6> {{ option.year }}</h6>
                                        </span>
                                    </div>
                                </template>
                            </vSelect>
                        </div>

                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="English Name" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="English Name" v-model="movie.en_title" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Arabic Name" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="Arabic Name" v-model="movie.ar_title" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>

                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Keywords" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="Keywords" v-model="movie.keywords" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="IMDB Rating" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" v-model="movie.rating" placeholder="Imdb Rating" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>

                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Trailer" rules="" v-slot="{ errors }">
                                    <vs-input class="w-full" v-model="movie.trailer" placeholder="Trailer" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">


                                <div class="vx-row">
                                    <div class="vx-col md:w-1/2">
                                        <ValidationProvider name="Imdb Link" rules=" " v-slot="{ errors }">
                                            <vs-input class="w-full" v-model="movie.imdb" placeholder="Imdb Link" />
                                            <span class="text-danger">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </div>
                                    <div class="vx-col  mt-5">
                                        <vs-button size="small" @click="getImdbData" class="rounded-lg ">
                                            Get Data
                                        </vs-button>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Release date" rules="" v-slot="{ errors }">
                                    <vs-input type="date" class="w-full" label-placeholder="Release date"
                                        v-model="movie.release_date" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Year" rules="required" v-slot="{ errors }">
                                    <vs-input class="w-full" label-placeholder="Year" v-model="movie.year" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <vs-input class="w-full" label-placeholder="Arabic tagline" v-model="movie.ar_tagline" />
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <vs-input class="w-full" label-placeholder="English tagline" v-model="movie.en_tagline" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="English Plot" rules="required" v-slot="{ errors }">
                                    <vs-textarea label="English Plot" v-model="movie.en_plot" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <ValidationProvider name="Arabic Plot" rules="required" v-slot="{ errors }">
                                    <vs-textarea label="Arabic Plot" v-model="movie.ar_plot" />
                                    <span class="text-danger">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="vx-row">

                            <div class="vx-col md:w-1/2 w-full mt-5">
                                <label for="">Rated</label>
                                <vSelect :filterable="true" :multiple="false" v-model="movie.rated"
                                    :options="movie.kind == 1 ? ['G', 'PG', 'PG-13', 'R', 'NC-17'] : ['TV-G', 'TV-PG', 'TV-Y', 'TV-14', 'TV-MA', 'TV-Y7']"
                                    placeholder="Select Rated">

                                </vSelect>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5" v-if="movie.episode == 0">
                                <label for="">Genres</label>
                                <vSelect :filterable="false" :multiple="true" v-model="movie.genres"
                                    :options="$store.state.genres.all" :reduce="genre => genre.id" label="ar_name"
                                    placeholder="Select genres">

                                </vSelect>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5" v-if="movie.episode == 0">
                                <label for="">Language</label>
                                <vSelect :filterable="false" :multiple="false" v-model="movie.language_id"
                                    :options="$store.state.languages.all" :reduce="language => language.id" label="ar_name"
                                    placeholder="Movie Language">

                                </vSelect>
                            </div>
                            <div class="vx-col md:w-1/2 w-full mt-5" v-if="movie.episode == 0">
                                <label for="">Collection</label>
                                <vSelect :filterable="false" :multiple="false" v-model="movie.collection"
                                    :options="$store.state.collections.all.data" placeholder="Select Collection">
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.en_name }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.en_name }}
                                        </div>
                                    </template>
                                </vSelect>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
            </div>
        </div>

    </div>
</template>

<script>
import {
    FormWizard,
    TabContent
} from 'vue-form-wizard'
import StarRating from 'vue-star-rating'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
export default {
    props: ['mData'],
    data() {
        return {
            firstName: "",
            imdbInfo: '',
            imdbId: '',
            status: false,
            seriesList: [],
            series_loading: false,
            movie: {
                id: 0,
                backdrop_path: '',
                comming_soon: false,
                ar_title: '',
                keywords: '',
                en_title: '',
                ar_tagline: '',
                en_tagline: '',
                ar_plot: '',
                en_plot: '',
                rating: '',
                rated: 'G',
                season: 0,
                episode: 0,
                series: '',
                duration: '',
                trailer: '',
                imdb: '',
                poster: '',
                kind: 1,
                release_date: '',
                year: '',
                poster_url: '',
                cover_url: '',
                genres: [],
                cast: [],
                language: [],
                language_id: 0,
                collection: 0,
                posterFile: ''
            }
            /// other data....
        }
    },
    created() {
        this.$store.dispatch('genres/fetchGenres');
        this.$store.dispatch('collections/fetchCollections', { page: 1, query: '' })
        this.$store.dispatch('languages/fetchLanguages')
        //this.imdbData();
        this.search()


    },
    mounted() {
        var vm = this;
        if (this.mData && this.mData.length != 0 && this.$store.state.languages.all != null) {
            this.movie.year = this.mData.response.year;
            this.movie.language_id = this.mData.response.language_id;
            this.movie.genres = this.mData.response.genres_ids;
            this.movie.kind = this.mData.response.kind;
            this.movie.id = this.mData.response.id;
            this.movie.ar_title = this.mData.response.ar_title;
            this.movie.en_title = this.mData.response.en_title;
            this.movie.ar_plot = this.mData.response.ar_plot;
            this.movie.en_plot = this.mData.response.en_plot;
            this.movie.trailer = this.mData.response.trailer;
            this.movie.ar_tagline = this.mData.response.ar_tagline;
            this.movie.en_tagline = this.mData.response.en_tagline;
            this.movie.release_date = this.mData.response.released_date;
            this.movie.keywords = this.mData.response.other_title;
            this.movie.rating = this.mData.response.rating;
            this.movie.imdb = this.mData.response.imdb;
            this.movie.rated = this.mData.response.rated;
            //this.movie.season = this.mData.response.season;
            this.movie.series = this.mData.response.series != undfend ? this.mData.response.series : 0;

            this.movie.episode = this.mData.response.episode;

            this.movie.en_plot = this.mData.response.en_plot;
            this.movie.ar_plot = this.mData.response.ar_plot;

            this.movie.collection = this.mData.response.collection;

        }
    },
    watch: {
        movie: {
            handler(val) {
                console.log('chane')
                this.seriesSelected()
            },
            deep: true

        }
    },
    methods: {

        getImdbData() {
            this.$vs.loading('#form')
            this.axios.get(`${this.$apiUrl}/v2/movies/imdb/${this.movie.imdb}`).then(res => {
                this.$vs.loading.close()
                this.movie.poster = res.data.poster
                this.movie.cover = res.data.cover
                this.movie.poster_url = res.data.poster
                this.movie.cover_url = res.data.cover
                this.movie.en_title = res.data.en_title
                this.movie.ar_title = res.data.en_title
                this.movie.keywords = res.data.ar_title
                this.movie.trailer = res.data.trailer
                this.movie.en_plot = res.data.en_plot
                this.movie.ar_plot = res.data.ar_plot
                this.movie.en_tagline = res.data.en_tagline
                this.movie.ar_tagline = res.data.ar_tagline
                this.movie.release_date = res.data.release_date
                this.movie.year = res.data.year
                this.movie.rating = res.data.rating
                this.movie.rated = res.data.rated
                this.movie.genres = res.data.genres
                this.movie.language_id = res.data.lang
                this.movie.collection = res.data.collection
                this.movie.kind = res.data.kind

            })
        },
        seriesSelected(option = null) {
            var vm = this
            var series = this.seriesList.filter((s) => {
                s.id == vm.movie.id
            })[0];
        },
        onFileChange(e) {
            const file = e.target.files[0];
            this.movie.posterFile = URL.createObjectURL(file);
        },
        search(query = '', loading = false) {
            this.series_loading = true
            this.axios.get(`${this.$apiUrl}/v2/movies?kind=2&search=${query}`).then(res => {
                this.seriesList = res.data.data
                setTimeout(() => {
                    this.series_loading = false
                }, 100);

            })
            return this.seriesList;
        },
        validate() {
            this.formSubmitted();
            return true
            return this.$refs.form.validate().then(result => {
                if (!result) {
                    return false;
                }
                this.formSubmitted();
                if (this.status) {
                    return true;
                } else {
                    return false;
                }
            })
        },
        formSubmitted() {
            var _status = false;
            const data = new FormData();
            this.$vs.loading()
            data.append('id', this.movie.id);
            data.append('comming_soon', this.movie.comming_soon);
            data.append('ar_title', this.movie.ar_title);
            data.append('en_title', this.movie.en_title);
            data.append('ar_tagline', this.movie.ar_tagline);
            data.append('en_tagline', this.movie.en_tagline);
            data.append('ar_plot', this.movie.ar_plot);
            data.append('en_plot', this.movie.en_plot);
            data.append('rating', this.movie.rating);
            data.append('rated', this.movie.rated);
            data.append('keywords', this.movie.keywords);
            data.append('season', this.movie.season);
            data.append('episode', this.movie.episode);
            data.append('duration', this.movie.duration);
            data.append('trailer', this.movie.trailer);
            data.append('imdb', this.movie.imdb);
            data.append('poster', this.movie.poster);
            data.append('poster_url', this.movie.poster_url);
            data.append('cover_url', this.movie.cover_url);
            data.append('kind', this.movie.kind);
            data.append('release_date', this.movie.release_date);
            data.append('year', this.movie.year);
            data.append('genres', JSON.stringify(this.movie.genres));
            data.append('series', this.movie.series);
            data.append('cast', JSON.stringify(this.movie.cast));
            data.append('language', this.movie.language_id);
            data.append('collection', JSON.stringify(this.movie.collection));
            data.append('posterFile', this.movie.posterFile);
            this.axios.post(`${this.$apiUrl}/movies`, data).then(res => {
                this.$vs.loading.close()
                this.$emit('success', res.data)
                if (this.movie.id == 0) {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Movie Addedd',
                        text: '',
                        position: 'bottom-center'
                    })
                } else {
                    this.$vs.notify({
                        color: 'primary',
                        title: 'Movie Updated',
                        text: '',
                        position: 'bottom-center'
                    })
                }

                this.movie.id = res.data.response.id;
                // this.pushToOld({
                //     name: this.movie.en_title,
                //     type: this.movie.kind == 1 ? 0 : 1,
                //     year: this.movie.year,
                //     disabled: false
                // });
                this.$router.push({ name: 'editMovie', params: { id: this.movie.id } })
                this.status = true;

            }).catch(errors => {
                this.$vs.loading.close();
                this.$vs.notify({
                    color: 'danger',
                    title: 'Movie was not Addedd',
                    text: ''
                })
            });
            return _status;
        },

     
    },
    components: {
        FormWizard,
        TabContent,
        vSelect, StarRating
    }
}
</script>
<style lang="scss">
.vs-input {
    width: 90%;
    margin-top: 10px;
}
</style>